import {
  ABOUT_HIGHLIGHTS_UPLOAD_REQUEST,
  ABOUT_HIGHLIGHTS_UPLOAD_SUCCESS,
  ABOUT_HIGHLIGHTS_UPLOAD_FAIL,
  ABOUT_HIGHLIGHTS_FETCH_REQUEST,
  ABOUT_HIGHLIGHTS_FETCH_SUCCESS,
  ABOUT_HIGHLIGHTS_FETCH_FAIL,
  ABOUT_HIGHLIGHTS_DELETE_REQUEST,
  ABOUT_HIGHLIGHTS_DELETE_SUCCESS,
  ABOUT_HIGHLIGHTS_DELETE_FAIL,
} from "../../constants/admin/aboutHighlightsConstants";

const initialState = {
  loading: false,
  success: false,
  error: null,
  aboutHighlights: [],
  message: null,
};

// 🔹 Single Reducer for about highlights actions
export const aboutHighlightsReducer = (state = initialState, action) => {
  switch (action.type) {
      case ABOUT_HIGHLIGHTS_UPLOAD_REQUEST:
      case ABOUT_HIGHLIGHTS_FETCH_REQUEST:
      case ABOUT_HIGHLIGHTS_DELETE_REQUEST:
          return { ...state, loading: true, success: false, error: null };

      case ABOUT_HIGHLIGHTS_UPLOAD_SUCCESS:
          return { ...state, loading: false, success: true, aboutHighlights: action.payload.aboutHighlights };

      case ABOUT_HIGHLIGHTS_FETCH_SUCCESS:
          return { ...state, loading: false, aboutHighlights: action.payload };

      case ABOUT_HIGHLIGHTS_DELETE_SUCCESS:
          return { ...state, loading: false, success: true, message: action.payload.message };

      case ABOUT_HIGHLIGHTS_UPLOAD_FAIL:
      case ABOUT_HIGHLIGHTS_FETCH_FAIL:
      case ABOUT_HIGHLIGHTS_DELETE_FAIL:
          return { ...state, loading: false, error: action.payload };

      default:
          return state;
  }
};
